import { render, staticRenderFns } from "./UnitSetting.vue?vue&type=template&id=f646722c&scoped=true&"
import script from "./UnitSetting.vue?vue&type=script&lang=js&"
export * from "./UnitSetting.vue?vue&type=script&lang=js&"
import style0 from "./UnitSetting.vue?vue&type=style&index=0&id=f646722c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f646722c",
  null
  
)

export default component.exports